import React, { useState } from "react";
import { Formik } from "formik";
import BaseInput from "../../base/BaseInput";
import { Link } from "react-router-dom";
import BaseButton from "../../base/BaseButton";
import { validateEmail } from "../../../utils/validateSchema";
import { forgotPasswordAction } from "../../../store/slices/auth/action";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import OrgAuthLayout from "../OrgAuthLayout";
import curlyHairImg from "../../../assets/img/curly_hair_girl.svg";
import { useAppDispatch } from "../../../store";
import { Platform } from "../../../enums/plaftorm.enum";

const ForgotPasswordForm = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  type FormValues = {
    email: string;
  };
  const initialValues: FormValues = {
    email: "",
  };

  const onSubmit = async (values: FormValues) => {
    try {
      setIsProcessing(true);
      const { payload } = await dispatch(
        forgotPasswordAction({
          email: values.email?.toLowerCase(),
          platform: Platform.OrganisationDashboard,
        })
      );
      if (payload.status === 200) {
        toast.success(payload?.message);
        setIsProcessing(false);
        navigate(`/reset-password?email=${values?.email?.toLowerCase()}`);
      }

      if (payload?.statusCode >= 400 && payload?.statusCode < 500) {
        setIsProcessing(false);
        return toast.error(payload?.message);
      }
      if (payload?.statusCode >= 500) {
        setIsProcessing(false);
        return toast.error("An unexpected error has occured! please try again");
      }
    } catch (error) {
      setIsProcessing(false);
    }
  };

  return (
    <OrgAuthLayout title="Forgot Password" bgImage={curlyHairImg}>
      <div className="text-center w-3/4 mx-auto page-bg-padding mt-[-9rem]">
        <div>
          <h3 className="text-[32px] font-medium text-[#2D2D31]">
            Forgot Password
          </h3>
          <p className="text-gray-600 text-lg pb-4">
            No worries, we’ll send you reset instructions
          </p>
          <div className="my-4">
            <Formik
              initialValues={initialValues}
              onSubmit={onSubmit}
              validate={validateEmail}
            >
              {(formik) => {
                const {
                  values,
                  touched,
                  isValid,
                  dirty,
                  handleChange,
                  handleSubmit,
                  errors,
                  handleBlur,
                } = formik;
                return (
                  <form onSubmit={handleSubmit}>
                    <BaseInput
                      id={"email"}
                      value={values.email}
                      label="Email address"
                      name={"email"}
                      type="email"
                      hasError={errors.email && touched.email}
                      change={handleChange}
                      blur={handleBlur}
                      errorMsg={errors.email}
                    />
                    <BaseButton
                      text="Reset Password"
                      variant="primary"
                      type="submit"
                      styles="w-full mt-4"
                      processing={isProcessing}
                      disabled={!(dirty && isValid)}
                    />
                  </form>
                );
              }}
            </Formik>
            <p className="flex justify-center mt-4">
              <Link to={"/login"} className="pl-1 primary_text_color ">
                Back to Log in
              </Link>
            </p>
          </div>
        </div>
      </div>
    </OrgAuthLayout>
  );
};

export default ForgotPasswordForm;
